<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3V12M12 21V12M12 12H21M12 12H3" stroke="#EA7C69" stroke-width="1.8" stroke-linecap="round"
          stroke-linejoin="round"/>
  </svg>

</template>

<script>
export default {
  name: "PlusIcon"
}
</script>

<style scoped>

</style>